import { sendHttpRequest } from "lib/fetcher";
export function getCustomers(orgId) {
  return sendHttpRequest({
    method: "get",
    url: "/user/customers",
    headers: {
      "x-org-id": orgId,
    },
  });
}

export function getDealerInfo() {
  return sendHttpRequest({
    method: "get",
    url: "/org/dealer",
  });
}
